/** Settings-store key: the Mini is docked into the display's top-center notch / menu bar band. */
export const MINI_NOTCHED_SETTING_KEY = 'mini.isNotched'

/** Settings-store key: when the Mini shows. Only `hidden` hides a notched Mini. */
export const MINI_VISIBILITY_SETTING_KEY = 'mini.visibility'
export type MiniVisibility = 'visible' | 'meetings' | 'hidden'
export const DEFAULT_MINI_VISIBILITY: MiniVisibility = 'visible'
